import React from "react";
import "./style/PageContent.css";

function AboutMe({ about }) {
  return (
    <div className="page-content">
      <h1 className="page-title">About Me</h1>
      <p className="page-description" style={{ whiteSpace: "pre-line" }}>
        {about.background}
      </p>
      <div className="page-section">
        <h2>Values</h2>
        <ul className="page-list">
          {about.values.map((value) => (
            <li key={value.valueName}>
              <strong>{value.valueName}:</strong> {value.description}
            </li>
          ))}
        </ul>
      </div>
      <div className="page-section">
        <h2>Interests</h2>
        <ul className="page-list">
          {about.interests.map((interest) => (
            <li key={interest.category}>
              <strong>{interest.category}:</strong> {interest.examples.join(", ")}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default AboutMe;
